import {getValue} from "../../utils/Fuc"
const fileds_map = {
    dev_name: "资产名称",
    dev_type_name: "资产类型",
    manage_org_name: "管理组织",
    use_org_name: "使用组织",
    use_user_name: "使用人",
    manage_user_name: "管理员",
    hall_name: "营业厅/办公点",
};


//获取变更内容
const getChangeContent = (content) => {
    let result = [];
    Object.keys(content).forEach((key) => {
        const filed_name = getValue(fileds_map, key, "");
        const value = content[key];
        const before_value=value[0]||'';
        const after_value=value[1]||'';
        if (filed_name && content[key]) {
            result.push(`【${filed_name}】从"${before_value}"变更为："${after_value}"`);
        }
    });

    return result.join("，");
}

export {
    fileds_map,
    getChangeContent
}